import DiscountLabel, { TDiscountLabel } from '@r1-frontend/ui-react/components/DiscountLabel';

type TPercentDiscountLabelProps = {
    children: number,
}

export type TPercentDiscountLabel = TPercentDiscountLabelProps & TDiscountLabel;

const PercentDiscountLabel = ({ children, ...props }: TPercentDiscountLabel): JSX.Element =>
    <DiscountLabel {...props}>
        -{children}%
    </DiscountLabel>;


export default PercentDiscountLabel;
